




























import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
import { l3draggable, l3droppable } from "@/directives/l3dragDrop";
// components
import CompImage from '../ExerciseComponents/CompImage.vue';
import ExpandableCard from '../Shared/ExpandableCard.vue';
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
// interfaces
import { namespace } from 'vuex-class';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { FileDetailsVm } from '@/interfaces/FileDetailsVm';
import MarkdownEditor from '../Shared/MarkdownEditor.vue';
import TusFileUploadOverlay from '../Shared/TusFileUploadOverlay.vue';
import CompHeroHeadline from '../ExerciseComponents/CompHeroHeadline.vue';

const globals = namespace("globals");

@Component({
    components: {
      CompImage,
      CompHeroHeadline,
      ExpandableCard,
      TusFileDrop,
      MarkdownEditor,
      TusFileUploadOverlay
    },
    directives: { l3draggable, l3droppable }
  })
  export default class HeroHeadlineElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  fileToUpload: File | null = null;

  mounted() {
  }

  onUploaded(filePath: string | null) {
    if (!filePath) return;
    this.element.contentUrl = filePath;
    this.element.aiSummary = "";
    this.element.altText = "";
    this.element.invisible = false;
  }

  onCancelled() {
    // this.fileToUpload = null;
  }

  get unsplashUrl() {
    // choose source text
    const raw = (this.element.imageLibrarySearchText && this.element.imageLibrarySearchText.trim() != "")
      ? this.element.imageLibrarySearchText.trim() : this.element.text?.trim();

    if (!raw || raw == "") {
      return "https://unsplash.com/de/s/fotos/Business?orientation=landscape&license=free";
    }

    // normalize, remove punctuation and symbol characters, then replace whitespace with '-'
    // uses Unicode property escapes to remove punctuation and symbols
    const sanitized = raw.normalize('NFC').replace(/[\p{P}\p{S}]/gu, '');
    let query = sanitized.replace(/\s+/g, '-');

    return `https://unsplash.com/de/s/fotos/${query}?orientation=landscape&license=free`;
  }

  get dropOptions() {
    return {
      accept: (data: any, ev?: DragEvent) => {
        // console.log("accept image called: parsed:", data, "types:", ev?.dataTransfer?.types, "effectAllowed:", ev?.dataTransfer?.effectAllowed);
        if (!data) return false;
        // Check for FileDetailsVm
        if (data?.fileType && (data.fileType == "Image")) return true;
        // Check for raw file array (dragged from OS / Browser)
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) return true;
        console.log("accept rejected");
        return false;
      },
      hoverClass: "drop-hover",
      transferTypes: ["Files"],
      targetGroups: ["image-file-details"],
      onDrop: (data: any) => {
        // console.log("Dropped data:", data);
        // Check for FileDetailsVm
        if (data?.fileType && (data.fileType == "Image")) {
          let fileDetails: FileDetailsVm = data;
          this.element.contentUrl = fileDetails.filePath;
          this.element.aiSummary = fileDetails.aiSummary || "";
          this.element.altText = "";
          this.element.invisible = false;
        } else
        // Check for raw file array (dragged from OS / Browser). The file list is converted to array in the directive
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) {
          // Check that it's an image file
          if (!data[0].type.startsWith("image/")) {
            this.$store.commit("ux/SB_FAILURE", {
              message: "Bei dieser Datei handelt es sich nicht um ein Bild.",
              timeout: 0
            });
            return;
          }
          this.fileToUpload = data[0]; // trigger upload overlay
        }
      }
    };
  }

  openUnsplash() {
    const url = this.unsplashUrl;
    if (typeof window !== 'undefined' && window.open) {
      window.open(url, '_blank', 'noopener,noreferrer,width=1000,height=800');
    // } else if (typeof globalThis !== 'undefined' && (globalThis as any).open) {
    //   (globalThis as any).open(url, '_blank', 'noopener,noreferrer,width=1000,height=800');
    } else {
      // no window available (SSR) — fallback: log or handle gracefully
      // eslint-disable-next-line no-console
      console.warn('Cannot open Unsplash: no window object available');
    }
  }
}
